import styled from 'styled-components'

export const Body = styled.div`
	overflow-y: auto;
	flex-grow: 1;
`
